import React from 'react';
import type { ShopTheme } from '../theme';

export const Field: React.FC<{
  theme: ShopTheme;
  label: string;
  hint?: string;
  error?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ theme, label, hint, error, className = '', children }) => (
  <label className={`block ${className}`}>
    <span
      className="mb-2 block"
      style={{
        font: `600 11px/1 ${theme.fontFamily}`,
        letterSpacing: '.16em',
        textTransform: 'uppercase',
        color: theme.label,
      }}
    >
      {label}
      {hint && (
        <span style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 400, color: theme.faint }}> {hint}</span>
      )}
    </span>
    {children}
    {error && (
      <span className="mt-1.5 block" role="alert" style={{ font: `400 13px/1.4 ${theme.fontFamily}`, color: theme.accent }}>
        {error}
      </span>
    )}
  </label>
);

